export const SETTINGS_PRETTY_OVERLAY_PRESET_STYLE_TEXT = `
body:has(.kg-settings-root[data-kg-settings-theme-mode="pretty"]) .kg-settings-modal-backdrop {
  --kg-settings-pretty-overlay-surface: var(--ds-surface-raised, Canvas);
  --kg-settings-pretty-overlay-surface-muted: var(--ds-surface-subtle, var(--ds-surface-raised, Canvas));
  --kg-settings-pretty-overlay-control: linear-gradient(180deg, var(--ds-surface-base, Canvas), color-mix(in srgb, var(--ds-surface-subtle, var(--ds-surface-raised, Canvas)) 98%, transparent));
  --kg-settings-pretty-overlay-border: var(--ds-border-subtle, currentColor);
  --kg-settings-pretty-overlay-border-strong: var(--ds-border-default, var(--ds-border-subtle, currentColor));
  --kg-settings-pretty-overlay-shadow: var(--ds-shadow-overlay, none);
  --kg-settings-pretty-overlay-shadow-rest: var(--ds-shadow-soft, var(--ds-shadow-overlay, none));
  --kg-settings-pretty-overlay-shadow-hover: var(--ds-shadow-hover, var(--ds-shadow-soft, var(--ds-shadow-overlay, none)));
  --kg-settings-pretty-overlay-shadow-press: var(--ds-shadow-press, var(--ds-shadow-soft, var(--ds-shadow-overlay, none)));
  --kg-settings-pretty-overlay-text: var(--ds-text, CanvasText);
  --kg-settings-pretty-overlay-text-subtle: var(--ds-text-subtle, var(--ds-text-muted, GrayText));
  --kg-settings-pretty-overlay-primary: var(--ds-accent-border, currentColor);
  --kg-settings-pretty-overlay-primary-hover: var(--ds-accent-hover, var(--ds-accent-border, currentColor));
  --kg-settings-pretty-overlay-primary-active: var(--ds-accent-active, var(--ds-accent-border, currentColor));
  --kg-settings-pretty-overlay-primary-text: var(--ui-text-on-brand, CanvasText);
  --kg-settings-pretty-overlay-danger: var(--ds-intent-danger-border, currentColor);
  --kg-settings-pretty-overlay-danger-text: var(--ds-intent-danger-text, CanvasText);
  --kg-settings-pretty-overlay-highlight: color-mix(in srgb, var(--ds-surface-base, Canvas) 88%, transparent);
  --kg-settings-pretty-overlay-focus: var(--ds-focus-ring, currentColor);
  --kg-settings-overlay-surface: var(--kg-settings-pretty-overlay-surface);
  --kg-settings-overlay-border: var(--kg-settings-pretty-overlay-border);
  --kg-settings-overlay-shadow: var(--kg-settings-pretty-overlay-shadow);
  --kg-settings-overlay-text: var(--kg-settings-pretty-overlay-text);
  --kg-settings-overlay-text-2: var(--kg-settings-pretty-overlay-text-subtle);
  --kg-settings-overlay-focus: var(--kg-settings-pretty-overlay-focus);
  --kg-settings-text: var(--kg-settings-pretty-overlay-text);
  --kg-settings-text-subtle: var(--kg-settings-pretty-overlay-text-subtle);
  --kg-settings-control-surface: var(--kg-settings-pretty-overlay-control);
  --kg-settings-inner-highlight: var(--kg-settings-pretty-overlay-highlight);
  --kg-settings-shadow-1: var(--kg-settings-pretty-overlay-shadow-rest);
  --kg-settings-shadow-2: var(--kg-settings-pretty-overlay-shadow-hover);
  --kg-settings-primary: var(--kg-settings-pretty-overlay-primary);
  --kg-settings-primary-hover: var(--kg-settings-pretty-overlay-primary-hover);
  --kg-settings-primary-active: var(--kg-settings-pretty-overlay-primary-active);
  --kg-settings-primary-text: var(--kg-settings-pretty-overlay-primary-text);
  --kg-settings-danger: var(--kg-settings-pretty-overlay-danger);
  --kg-settings-danger-text: var(--kg-settings-pretty-overlay-danger-text);
  background: var(--kg-settings-pretty-overlay-scrim, color-mix(in srgb, var(--ds-text, currentColor) 24%, transparent)) !important;
  color: var(--kg-settings-pretty-overlay-text) !important;
}
`;
